<template>
    <v-dialog
        transition="dialog-top-transition"
        max-width="700"
        v-model="confirmDelete"
    >
        <v-card class="pt-2 pb-2">
            <div class="d-flex justify-space-between px-4">
                <h1 class="px-3 font-weight-light text-center">
                    ¿Está seguro de que quiere borrar este elemento?
                </h1>
                <v-icon size="90" color="orange">
                    mdi-alert
                </v-icon>
            </div>
            <div class="pt-4">
                <p class="px-6 font-weight-light text-center">
                    <v-icon color="red">mdi-delete</v-icon>
                    Recuerde proceder con cautela, este cambio podría ser irreversible  y afectar a la consistencia en los datos ya existentes en la base de datos. Consulte con los administradores si no está seguro de lo que está haciendo.
                </p>
                
            </div>

            <v-card-actions class="justify-end">
                <v-btn text color="red" @click="closeForm">
                    Cerrar
                </v-btn>
                <v-btn color="red" dark @click="deleteElement">
                    Borrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ManagementConfirmDeletion',

    methods: {
        closeForm() {
            this.$store.commit('ManagementBase/confirmDeletion', {
                val: false,
                deleteData: null,
            });
        },
        async deleteElement() {
            await this.$store.dispatch('ManagementBase/deleteObject');
            this.closeForm();
        },
    },
    computed: {
        confirmDelete: {
            get() {
                return this.$store.state.ManagementBase.confirmDeletion;
            },
            set() {
                this.closeForm();
            },
        },
    },
};
</script>
